export const sortTypes = ['Low to High', 'High to Low'];

export const priceRangeValue = [0, 10000];
